<template>
    <div class="c2b-container">
        <div class="c2b-router-name-container">
            <p class="c2b-router-name">Vendedores</p>
        </div>

        <div class="c2b-content">
            <div class="modal" tabindex="-1" role="dialog" id="c2b-seller-list-filter-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Filtro</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Nome</label>
                                    <input type="text" 
                                        class="form-control"
                                        v-model="sellerFilterForm.name" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Email</label>
                                    <input type="text" 
                                        class="form-control"
                                        v-model="sellerFilterForm.email" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Chave pública</label>
                                    <input type="text" 
                                        class="form-control"
                                        v-model="sellerFilterForm.publicKey" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Id externo</label>
                                    <input type="text" 
                                        class="form-control"
                                        v-model="sellerFilterForm.idExternal" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Tipo</label>
                                    <multiselect
                                        v-model="sellerFilterForm.typeList"
                                        :options="sellerTypeList"
                                        :multiple="true"
                                        :show-labels="false"
                                        label="description"
                                        track-by="enum"
                                        placeholder="" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                @click="getSellerListWithFilter(sellerFilterForm)"
                                :disabled="loadingFilter">
                                    Filtrar
                                    <Loading v-show="loadingFilter" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="clearFilter()">Restaurar</button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeFilterModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <SellerAccountStatementCmp ref="sellerAccountStatementCmp"/>

            <Loading v-if="loading" />

            <div v-show="!loading">
                <div class="mb-3">
                    <button class="btn btn-primary" @click="openFilterModal()">
                        Filtro
                    </button>

                    <div class="btn-group ml-3" 
                        v-show="userAuthenticated.hasRoleAdmin() || userAuthenticated.hasRoleBiller() || userAuthenticated.hasRoleSellerOperator()">
                        <div class="btn-group">
                            <button type="button" 
                                class="btn btn-outline-secondary dropdown-toggle" 
                                data-toggle="dropdown">
                                Relatórios
                            </button>
                            <div class="dropdown-menu">
                                <span class="dropdown-item"
                                    @click="gotoSellerBalanceList()">
                                    Saldo consolidado
                                </span>

                                <span class="dropdown-item"
                                    @click="gotoSellerComissionList()">
                                    Comissão
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <FilterInformationCmp 
                    v-if="!loading"
                    :filter-submitted="sellerFilterSubmitted"
                    :filter-properties="sellerFilterProperties" />

                <NothingFound v-if="nothingToShow" />

                <div class="table-responsive" v-show="!nothingToShow">
                    <table class="table table-hover table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Código C2B</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(seller, index) of sellerList" :key="index">
                                <td>
                                    <p class="mb-0">{{seller.realName}}</p>
                                    <small class="text-muted">{{seller.name}}</small>
                                </td>
                                <td>{{seller.id}}</td>
                                <td class="text-center c2b-td-with-buttons">
                                    <button type="button" 
                                        class="btn btn-default text-muted" 
                                        data-toggle="dropdown" >
                                        <fa icon="ellipsis-v" v-show="!seller.loadingListAction"/>
                                        <fa icon="sync-alt" spin v-show="seller.loadingListAction"/>
                                    </button>

                                    <div class="dropdown-menu">                                        
                                        <span class="dropdown-item"
                                            @click="openAccountStatementListModal(seller)">Visualizar extrato</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <ListCount :amount="sellerList.length" />
                </div>

                <div v-if="showPaginationButton" class="text-center">
                    <button class="btn btn-outline-secondary"
                        @click="getMoreSellers()"
                        :disabled="loadingNextPage">
                        <span v-show="!loadingNextPage">Mais resultados</span>
                        <fa v-show="loadingNextPage" icon="sync-alt" spin/>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { PaginationModel } from '@/utils/models/PaginationModel'
import { SellerListFilterFormModel } from '../models/SellerListFilterFormModel'
import sellerService from '../services/SellerService'
import FilterInformationCmp from '@/utils/components/FilterInformationCmp'
import ModalService from '@/utils/services/ModalService'
import { cloneDeep } from 'lodash'
import { SellerModel } from '../models/SellerModel'
import { SellerAccountStatementModel } from '../../seller/models/SellerAccountStatementModel'
import { dateFilter } from '@/utils/filters/DateTimeFilter'
import { mapState } from 'vuex'
import SellerAccountStatementCmp from '../components/SellerAccountStatementCmp'

const ID_SELLER_LIST_FILTER_MODAL = '#c2b-seller-list-filter-modal'

export default {
    name: 'SellerListView',
    filters: {
        dateFilter,
    },
    components: {
        FilterInformationCmp,
        SellerAccountStatementCmp,
    },
    data() {
        return {
            loading: true,
            loadingNextPage: false,
            loadingFilter: false,
            showPaginationButton: true,                        
            sellerList: [],
            seller: new SellerModel(),
            sellerTypeList: SellerListFilterFormModel.getSellerTypeList(),
            sellerFilterForm: new SellerListFilterFormModel(),
            sellerFilterSubmitted: new SellerListFilterFormModel(),
            pagination: new PaginationModel(),
            sellerFilterProperties: [
                {
                    type: 'string',
                    label: 'Nome',
                    property: 'name',
                },
                {
                    type: 'string',
                    label: 'Email',
                    property: 'email',
                },
                {
                    type: 'string',
                    label: 'Chave pública',
                    property: 'publicKey',
                },
                {
                    type: 'string',
                    label: 'Id externo',
                    property: 'idExternal',
                },
                {
                    type: 'list',
                    label: 'Tipo',
                    property: 'typeList',
                    propertyInList: 'description',
                },
            ],
        }
    },
    async mounted() {
        this.loading = true

        try {
            this.sellerList = await sellerService.getSellerList(this.pagination.actual(), this.sellerFilterForm)
            if (!this.sellerList.length) {
                this.showPaginationButton = false
            } else {
                this.pagination.next()
            }
        } catch (err) {
            this.showPaginationButton = false
            
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
    methods: {
        async getMoreSellers() {
            this.loadingNextPage = true

            try {
                const sellerList = await sellerService.getSellerList(this.pagination.actual(), this.sellerFilterForm)
                if (sellerList.length) {
                    this.sellerList.push(...sellerList)
                    this.pagination.next()
                } else {
                    this.showPaginationButton = false
                }
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }            

            this.loadingNextPage = false
        },
        async getSellerListWithFilter(sellerFilter) {
            this.loadingFilter = true

            this.sellerFilterSubmitted = cloneDeep(sellerFilter)
            
            try {
                this.pagination.reset()
                this.sellerList = await sellerService.getSellerList(this.pagination.actual(), this.sellerFilterSubmitted)
                if (!!this.sellerList.length) {
                    this.showPaginationButton = true
                    this.pagination.next()
                } else {
                    this.showPaginationButton = false
                }
                this.closeFilterModal()
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.loadingFilter = false
        },
        clearFilter() {
            this.sellerFilterForm = new SellerListFilterFormModel()
        },
        async openFilterModal() {
            ModalService.show(ID_SELLER_LIST_FILTER_MODAL)
        },
        closeFilterModal() {
            ModalService.hide(ID_SELLER_LIST_FILTER_MODAL)
        },
        async openAccountStatementListModal(seller) {
            await this.$refs.sellerAccountStatementCmp.openAccountStatementListModal(seller)
        },
        gotoSellerBalanceList() {
            this.$router.push('/vendedores/relatorios/saldo-consolidado')
        },
        gotoSellerComissionList() {
            this.$router.push('/vendedores/relatorios/comissao')
        },
        async _getAndParseSellerAccountStatement(seller, sellerAccountStatementFilterForm) {
            const accountStatementList = await sellerService.getSellersAccountStatement(seller.id, sellerAccountStatementFilterForm)

            return accountStatementList.map((as) => {
                return new SellerAccountStatementModel(Object.assign({},  as, {visible: false}))
            })
        },
    },
    computed: {
        ...mapState({
            userAuthenticated: state => state.userAuthenticated,
        }),
        nothingToShow() {
            return !this.loading && !this.sellerList.length
        },
    },
}
</script>

